'use client'
import * as Sentry from '@sentry/nextjs'
import * as React from 'react'
import { RegistrationSource } from '@repo/auth-utils'
import { UserAuthModalProvider } from '@repo/user-auth-dialog/user-auth-dialog-context'
import { Footer } from '@repo/web-ui/components/cf-footer'
import { CfHeader } from '@repo/web-ui/components/cf-header'
import { Providers } from '@repo/web-ui/components/providers'

import { Search } from '@web/components/not-found/search'

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  React.useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className={'font-poppins antialiased'}>
      <Providers>
        <UserAuthModalProvider
          registrationSource={RegistrationSource.Marketplace}
          trackingOptions={{ registrationConversion: true }}
        >
          <CfHeader />
          <div
            className="m-auto flex w-full flex-col items-center bg-[#f6f7fb] px-4 py-32 min-[1175px]:px-12 "
            style={{ '--hover-bg-color': '#2a1f3f', '--bg-color': '#493675' }}
          >
            <div className="mb-12 w-full text-center">
              <h1 className="mb-4 text-[30px] font-bold">Oops! Something went wrong!</h1>
              <button
                className="font-poppins text-service-white m-auto flex min-h-[45px] w-fit items-center justify-center rounded bg-[--bg-color] p-2 px-6 text-[1rem] font-bold uppercase hover:bg-[--hover-bg-color]"
                onClick={() => {
                  window.location.reload()
                }}
              >
                Try again
              </button>
            </div>
            <div className="pb-6 text-red-100 ">
              <span className="font-semibold">Unexpected error:</span>{' '}
              <span className="font-normal">
                {(error as Error)?.message
                  ? (error as Error)?.message
                  : (error as unknown as string)}
              </span>
            </div>
            <p className="text-14 mb-6">Please try searching for some products instead:</p>
            <Search />
          </div>
          <Footer />
        </UserAuthModalProvider>
      </Providers>
    </div>
  )
}
